import React from 'react';
import { Text } from '@fiverr-private/typography';
import { AppI18n } from '../../../../i18n';
import { ViewComponentProps } from '../..';
import { isLanguagesPairValid } from './utils';

export const ViewLanguagePairs = ({ section }: ViewComponentProps) => {
  const fromLabel =
    (section as any).metadata?.allAnswers?.find((a: any) => a.slug === section.content[0])?.display_name ||
    section.content[0];
  const toLabel =
    (section as any).metadata?.allAnswers?.find((a: any) => a.slug === section.content[1])?.display_name ||
    section.content[1];

  return isLanguagesPairValid(section.content as unknown as string[]) ? (
    <Text>
      <AppI18n
        k={'sections.language_pairs.translate_from_to'}
        params={{
          from: fromLabel,
          to: toLabel,
        }}
      />
    </Text>
  ) : (
    <Text>
      (<AppI18n k={'sections.mandatory'} />)
    </Text>
  );
};
